// extracted by mini-css-extract-plugin
module.exports = {"container":"Input_container__I7Bjk","label":"Input_label__2uIVE","inputbox":"Input_inputbox__1UEWx","input":"Input_input__SCFHN","star":"Input_star__-mP53"};